/**
 * Vue mixin for filter functionality within assessment screen.
 * @author cm359n
 */

export default {

  methods: {
    capitalise (str) {
      if (typeof str === 'string' && str.length > 0) {
        const ret = str[0].toUpperCase() + str.substring(1)
        return ret
      } else {
        return str
      }
    },
    displayName (filter) {
      let ret = filter.name
      if (ret.length > 0) {
        ret = this.capitalise(ret)
      }
      if (typeof filter.displayName !== 'undefined') {
        ret = filter.displayName
      }
      return ret
    },
    collectFilters (filters, filterDates) {
      let toApply = []
      // so, filters[<each type>] has:
      //         selected[0: true, 1: true] to keep track of which filters were selected (this is also used in the v-model)
      //     and fmap[0: 'foo', 1: 'bar'] specifies the filter string for the comparison
      //          (i wanted to keep strings like course names which could potentially contain all sorts of things, out of Vue's v-model)
      for (const criteria in filters) {
        const selectedFilters = filters[criteria].selected

        for (const filt in selectedFilters) {
          const optionSelected = selectedFilters[filt]
          // console.log('was option ' + filt + ' selected? ' + optionSelected)
          if (optionSelected) {
            const optionValue = filters[criteria].fmap[filt]
            if (criteria in toApply) {
              toApply[criteria].push(optionValue)
            } else {
              console.log('adding option ' + optionValue)
              toApply[criteria] = [optionValue]
              if (criteria == 'dates' && optionValue == 'Range') {
                toApply[criteria] = ['Range|' + filterDates.from + '|' + filterDates.to]
              }
            }
          }
        }
      }
      return toApply
    },
    applyFilters (toApply, deadlines) {
      let ret = []
      // and actually go through the deadlines object and filter here...
      const numFilters = Object.keys(toApply).length
      const requestedFilterList = Object.keys(toApply)

      // display filter list before we start
      if (numFilters > 0) {
        console.log('filtering on ....')
        console.log(toApply)
      } else {
        console.log('no filters applied')
      }

      for (let deadline of deadlines) {
        if (numFilters > 0) {
          // go through each filter, which may contain multiple values...
          let filterMatches = 0
          for (let filter of requestedFilterList) {
            const valuesToMatch = toApply[filter]
            console.log('[' + filter + '] need to match one of: ' + valuesToMatch)
            let fieldNames = this.propertyForFilter(filter)
            if (typeof fieldNames !== 'undefined') {
              // lookup successful. we found the field name corresponding to this filter
              for (let val of valuesToMatch) {
                // use (A) each filter value that was selected. if it contains '|' (as in the moodle course name), use the value on the right
                // the values in the course filter look like "My Awesome Course With A Long Name!|AWESM_COURSE_123"
                let compVal = val
                if (val.indexOf('|') != -1) {
                  const multVals = val.split('|')
                  compVal = multVals[multVals.length - 1]
                }
                // get (B) the value of the field in the deadline object
                let fieldVal = deadline[fieldNames[fieldNames.length - 1]]
                // compare A and B
                // console.log('comparing deadline ' + fieldNames[fieldNames.length - 1] + ' value ' + fieldVal + ' to ' + compVal + '.')
                if (compVal == fieldVal) {
                  filterMatches++
                }
              }
            } else {
              // could be dates filter
              if (filter == 'dates') {
                // figure out beginning of week, end of week, end of month
                let pastSunday = this.getDayInWeek(0)
                let nextSunday = this.getDayInWeek(7)
                let startMonth = this.getSpecificDayOfMonth(1)
                let endMonth = new Date(startMonth)
                endMonth.setMonth(endMonth.getMonth() + 1)
                // console.log('this week starts at ' + pastSunday + ' and ends at ' + nextSunday)
                // console.log('this month starts at ' + startMonth + ' and ends at ' + endMonth)
                let fieldVal = deadline['duedate']
                for (let val of valuesToMatch) {
                  if (val == 'This week' && fieldVal > (pastSunday.getTime() / 1000) && fieldVal < (nextSunday.getTime() / 1000)) {
                    filterMatches++
                  } else if (val == 'This month' && fieldVal > (startMonth.getTime() / 1000) && fieldVal < (endMonth.getTime() / 1000)) {
                    filterMatches++
                  } else if (val.startsWith('Range')) {
                    // TODO compare date range
                    // need to parse out e.g. Range|2022-06-21|2022-06-25 (range|date from|date to)
                    const dates = val.split('|')
                    if (dates.length == 3) { // compare the dates as strings YYYY-MM-DD to avoid dealing with times/timezones...
                      const fvDateObj = new Date(fieldVal * 1000)
                      const fvAsYmd = fvDateObj.toISOString().split('T')[0]

                      // console.log('checking if ' + fvAsYmd + ' is between ' + dates[1] + ' and ' + dates[2])
                      if (fvAsYmd >= dates[1] && fvAsYmd <= dates[2]) {
                        filterMatches++
                      }
                    } else {
                      console.log('cannot filter on dates given - criteria were not provided correctly (Range|start date|end date)')
                    }
                  }
                }
              } else {
                console.log('*** field name for filter ' + filter + ' not found!')
              }
            }
          }
          // console.log('deadline matched ' + filterMatches + ' of ' + numFilters + ' filter(s).')
          if (filterMatches == numFilters) {
            ret.push(deadline)
          }
        } else {
          // just add it back in
          ret.push(deadline)
        }
      }
      if (requestedFilterList.length != 0) {
        console.log('out of ' + deadlines.length + ', ' + ret.length + ' matched the filters [' + requestedFilterList + ']')
      }
      return ret
    },
    propertyForFilter (fname) {
      const pff = {
        'course': ['moodlecourse', 'shortname'], /* optionally shortname because moodlecourse could be lonnnnggg */
        'topic': ['coursename'], /* i know, i know */
        'status': ['status'],
        'type': ['assessmenttype']
      }
      return pff[fname]
    },
    getDayInWeek (daysFromStart) {
      let dte = new Date()
      let currentDay = dte.getDay()
      let distance = daysFromStart - currentDay
      return this.getSpecificDayOfMonth(dte.getDate() + distance)
    },
    getSpecificDayOfMonth (ddate) {
      let dte = new Date()
      dte.setDate(ddate)
      dte.setHours(0)
      dte.setMinutes(0)
      dte.setSeconds(0)
      dte.setMilliseconds(0)
      return dte
    }
  }
}
